$rise_devtools_plugin $mol_plugin
	auto /
		<= keydown_listener null $mol_dom_listener
		<= selector $rise_devtools_selector
			active? <=> selecting? false
			done? <=> selector_done? null
			rpc_port <= rpc_port \9091
	selecting? false
	rpc_port \9091
